(function () {
  const $ = s => document.querySelector(s);
  let qty = 1;

  // Nav: hide while scrolling down, reveal on scroll up
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    const nav = $('.nav');
    if (!nav) return;
    const y = window.scrollY;
    if (y > 10) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');

    if (Math.abs(y - lastScrollY) < 6) return;
    if (y > lastScrollY && y > nav.offsetHeight) nav.classList.add('nav-hidden');
    else nav.classList.remove('nav-hidden');
    lastScrollY = y;
  }, { passive: true });

  const swatchWrap = $('#swatches');
  const sizeWrap = $('#sizes');
  const drawer = $('#cartDrawer'), backdrop = $('#cartBackdrop');

  function openCart() { drawer.classList.add('open'); backdrop.classList.add('open') }
  function closeCart() { drawer.classList.remove('open'); backdrop.classList.remove('open') }

  function currentColor() {
    const active = swatchWrap && swatchWrap.querySelector('button.active');
    return active ? active.dataset.color.toUpperCase() : '';
  }
  function currentSize() {
    const active = sizeWrap && sizeWrap.querySelector('button.active');
    return active ? active.dataset.size : '';
  }
  function getCurrentVariant() {
    const size = currentSize();
    const color = currentColor();
    if (window.SEEPA_VARIANTS) {
      return window.SEEPA_VARIANTS.find(v =>
        (v.option1 && v.option1.toUpperCase() === size && v.option2 && v.option2.toUpperCase() === color) ||
        (v.option2 && v.option2.toUpperCase() === size && v.option1 && v.option1.toUpperCase() === color) ||
        (v.option1 && v.option1.toUpperCase() === color && !v.option2) ||
        (v.option1 && v.option1.toUpperCase() === size && !v.option2)
      );
    }
    return null;
  }

  function currentVariantId() {
    const v = getCurrentVariant();
    if (v) return v.id;
    const active = sizeWrap && sizeWrap.querySelector('button.active');
    const colorActive = swatchWrap && swatchWrap.querySelector('button.active');
    return (colorActive && colorActive.dataset.variantId) || (active && active.dataset.variantId) || (window.SEEPA_PRODUCT && window.SEEPA_PRODUCT.selectedVariantId);
  }

  function sync() {
    const color = currentColor(), size = currentSize();
    if ($('#qty')) $('#qty').textContent = qty;
    if ($('#selectedColor')) $('#selectedColor').textContent = color;
    if ($('#drawerVariant')) $('#drawerVariant').textContent = color + ' · ' + (window.SEEPA_I18N ? window.SEEPA_I18N.size : 'SIZE') + ' ' + size;

    if (sizeWrap && window.SEEPA_VARIANTS) {
      sizeWrap.querySelectorAll('button').forEach(btn => {
        const btnSize = btn.dataset.size;
        const v = window.SEEPA_VARIANTS.find(x =>
          (x.option1 && x.option1.toUpperCase() === btnSize && x.option2 && x.option2.toUpperCase() === color) ||
          (x.option2 && x.option2.toUpperCase() === btnSize && x.option1 && x.option1.toUpperCase() === color) ||
          (x.option1 && x.option1.toUpperCase() === btnSize && !x.option2)
        );
        btn.disabled = v ? !v.available : true;
      });
    }

    const v = getCurrentVariant();
    const img = document.querySelector('.purchase-media img');
    if (v) {
      if (v.image && img) img.src = v.image;
      const addBtn = $('#addCart');
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.style.opacity = '1';
          addBtn.innerHTML = (window.SEEPA_I18N ? window.SEEPA_I18N.add_to_cart : 'ADD TO CART') + ' · <span id="buyColor">' + color + '</span>';
        } else {
          addBtn.disabled = true;
          addBtn.style.opacity = '0.5';
          addBtn.textContent = window.SEEPA_I18N ? window.SEEPA_I18N.out_of_stock : 'OUT OF STOCK';
        }
      }
    } else {
      const activeColor = swatchWrap && swatchWrap.querySelector('button.active');
      if (activeColor && activeColor.dataset.image && img) {
        img.src = activeColor.dataset.image;
      }
      const addBtn = $('#addCart');
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
        addBtn.innerHTML = (window.SEEPA_I18N ? window.SEEPA_I18N.add_to_cart : 'ADD TO CART') + ' · <span id="buyColor">' + color + '</span>';
      }
    }
  }

  if ($('#plus')) $('#plus').onclick = () => { qty++; sync() };
  if ($('#minus')) $('#minus').onclick = () => { qty = Math.max(1, qty - 1); sync() };

  if (swatchWrap) {
    swatchWrap.querySelectorAll('button').forEach(b => b.onclick = () => {
      swatchWrap.querySelectorAll('button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      sync();
    });
  }
  if (sizeWrap) {
    sizeWrap.querySelectorAll('button').forEach(b => b.onclick = () => {
      sizeWrap.querySelectorAll('button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      sync();
    });
  }

  async function fetchCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if ($('#cartCount')) $('#cartCount').textContent = cart.item_count;
      if ($('#cartHeadCount')) $('#cartHeadCount').textContent = cart.item_count;
      return cart;
    } catch (e) { console.error('Cart fetch error', e); }
  }

  window.updateCartItem = async function (key, newQty, button) {

    // Prevent duplicate requests
    if (button?.dataset.loading === 'true') return;

    const row = button?.closest('.cart-qty-row');

    if (row) {
      row.classList.add('is-loading');
    }

    if (button) {
      button.dataset.loading = 'true';
    }

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: newQty
        })
      });

      if (!res.ok) {
        throw new Error('Cart update failed');
      }

      await renderDrawerFromCart();

    } catch (e) {
      console.error('Cart update error:', e);

    } finally {
      if (row) {
        row.classList.remove('is-loading');
      }

      if (button) {
        button.dataset.loading = 'false';
      }
    }
  };

  async function renderDrawerFromCart() {
    const cart = await fetchCartCount();
    if (!cart) return;
    if ($('#drawerTotal')) $('#drawerTotal').textContent = cart.item_count ? (cart.total_price / 100).toLocaleString(undefined, { style: 'currency', currency: cart.currency || 'USD' }).replace(/Dhs\.?/g, 'AED') : '—';
    const container = $('#cartItemsContainer');
    const shippingBar = $('.cart-shipping');
    const trustBlock = $('.cart-trust');
    const announceBar = $('.cart-announce');
    if (container) {
      if (cart.items && cart.items.length) {
        if (shippingBar) shippingBar.style.display = '';
        if (trustBlock) trustBlock.style.display = '';
        if (announceBar) announceBar.style.display = '';
        container.innerHTML = cart.items.map(item => `
          <div class="cart-item" style="display:flex; gap:15px; padding:24px 0; border-bottom:1px solid var(--line);">
            <img src="${item.image || ''}" alt="${item.title}" style="width:90px;height:90px;object-fit:contain;background:#fff;">
            <div style="flex:1;">
              <strong style="font-size:12px;letter-spacing:.1em">${item.product_title}</strong>
              <small style="display:block;color:var(--muted);margin-top:8px;">${item.variant_title || ''}</small>
              <div class="cart-qty-row" style="display:flex; justify-content:space-between; align-items:center; margin-top:10px;">
                <div class="qty" style="height:32px; border:1px solid #aaa59a; display:flex;">
                <button
  type="button"
  onclick="window.updateCartItem('${item.key}', ${Math.max(0, item.quantity - 1)}, this)"
  style="width:30px;background:none;border:none;cursor:pointer;"
>
  −
</button>

<span style="display:grid;place-items:center;width:30px;font-size:12px;">
  ${item.quantity}
</span>

<button
  type="button"
  onclick="window.updateCartItem('${item.key}', ${item.quantity + 1}, this)"
  style="width:30px;background:none;border:none;cursor:pointer;"
>
  +
</button>  
                </div>
                 <button type="button" onclick="window.updateCartItem('${item.key}', 0)" aria-label="${window.SEEPA_I18N ? window.SEEPA_I18N.remove : 'Remove'}" style="background:none; border:none; cursor:pointer; color:var(--muted); display:inline-flex; padding:2px;">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 6h18"/>
                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                    <line x1="10" y1="11" x2="10" y2="17"/>
                    <line x1="14" y1="11" x2="14" y2="17"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        `).join('');
        if ($('.cart-bottom')) $('.cart-bottom').style.display = 'block';
      } else {
        const rootUrl = window.SEEPA_ROOT_URL || '/';
        container.innerHTML = `
          <div class="cart-empty">
            <p>${window.SEEPA_I18N ? window.SEEPA_I18N.cart_empty : 'Your cart is empty.'}</p>
            <a class="outline" href="${rootUrl}#purchase" onclick="window.closeCart && window.closeCart()">${window.SEEPA_I18N ? window.SEEPA_I18N.continue_shopping : 'CONTINUE SHOPPING'}</a>
          </div>
        `;
        if (shippingBar) shippingBar.style.display = 'none';
        if (trustBlock) trustBlock.style.display = 'none';
        if (announceBar) announceBar.style.display = 'none';
        if ($('.cart-bottom')) $('.cart-bottom').style.display = 'none';
      }
    }
    renderCrossSell(cart);
  }

  // Recommends the other color of the same product for whatever is currently in the cart.
  async function renderCrossSell(cart) {
    const wrap = $('#cartCrosssell');
    const scroll = $('#cartCrosssellScroll');
    if (!wrap || !scroll) return;

    if (!cart.items || !cart.items.length) {
      wrap.style.display = 'none';
      scroll.innerHTML = '';
      return;
    }

    try {
      const item = cart.items[0];
      const handle = item.url.split('?')[0].split('/').pop();
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Product fetch failed');
      const product = await res.json();
      console.log(product);
      

      const colorIndex = product.options.findIndex(o => o.name.toLowerCase() === 'color');
      if (colorIndex === -1) { wrap.style.display = 'none'; scroll.innerHTML = ''; return; }
      const optKey = 'option' + (colorIndex + 1);

      const variantById = {};
      product.variants.forEach(v => { variantById[v.id] = v; });

      const cartColors = new Set(
        cart.items
          .filter(i => i.product_id === item.product_id)
          .map(i => variantById[i.variant_id])
          .filter(Boolean)
          .map(v => (v[optKey] || '').toLowerCase())
      );

      const altVariant = product.variants.find(v => v.available && !cartColors.has((v[optKey] || '').toLowerCase()));

      if (!altVariant) {
        wrap.style.display = 'none';
        scroll.innerHTML = '';
        return;
      }

      wrap.style.display = 'block';
      const currency = cart.currency || 'USD';
      const img = (altVariant.featured_image && altVariant.featured_image.src) || product.featured_image || '';
      const price = (altVariant.price / 100).toLocaleString(undefined, { style: 'currency', currency }).replace(/Dhs\.?/g, 'AED');
      const compareAt = (altVariant.compare_at_price && altVariant.compare_at_price > altVariant.price)
        ? (altVariant.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency }).replace(/Dhs\.?/g, 'AED')
        : '';

      scroll.innerHTML = `
        <div class="cart-crosssell-card">
          <img src="${img}" alt="${product.title}">
          <strong>${product.title}</strong>
          <small>${altVariant.public_title || altVariant.title}</small>
          <div class="cart-crosssell-price">
            ${compareAt ? `<span class="cart-crosssell-compare">${compareAt}</span>` : ''}
            <span>${price}</span>
          </div>
          <button type="button" class="cart-crosssell-add" data-variant-id="${altVariant.id}">${window.SEEPA_I18N ? window.SEEPA_I18N.add : 'ADD'}</button>
        </div>
      `;

      const addBtn = scroll.querySelector('.cart-crosssell-add');
      if (addBtn) {
        addBtn.addEventListener('click', async () => {
          if (addBtn.dataset.loading === 'true') return;
          addBtn.dataset.loading = 'true';
          const originalText = addBtn.textContent;
          addBtn.textContent = window.SEEPA_I18N ? window.SEEPA_I18N.adding : 'ADDING...';
          try {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(addBtn.dataset.variantId, 10), quantity: 1 }] })
            });
            if (!addRes.ok) throw new Error('Add to cart failed');
            await renderDrawerFromCart();
          } catch (e) {
            console.error('Cross-sell add error:', e);
            addBtn.textContent = window.SEEPA_I18N ? window.SEEPA_I18N.try_again : 'TRY AGAIN';
            setTimeout(() => { addBtn.textContent = originalText; }, 1500);
          } finally {
            addBtn.dataset.loading = 'false';
          }
        });
      }
    } catch (e) {
      console.error('Cross-sell fetch error:', e);
      wrap.style.display = 'none';
      scroll.innerHTML = '';
    }
  }

  if ($('#addCart')) {
  $('#addCart').addEventListener('click', async function () {

    const button = this;

    // Prevent double clicks
    if (button.dataset.loading === 'true') return;

    const variantId = currentVariantId();

    if (!variantId) {
      openCart();
      return;
    }

    // Save the normal button content
    const originalHTML = button.innerHTML;

    // Start loading state
    button.dataset.loading = 'true';
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    button.innerHTML = `
      <span class="add-cart-spinner"></span>
      <span>${window.SEEPA_I18N ? window.SEEPA_I18N.adding : 'ADDING...'}</span>
    `;

    try {

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: qty
            }
          ]
        })
      });

      if (!res.ok) {
        throw new Error('Add to cart failed');
      }

      // IMPORTANT:
      // Stop the button loading state immediately after
      // Shopify confirms the item was added.
      button.dataset.loading = 'false';
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');

      // Restore normal button
      button.innerHTML = originalHTML;

      // Refresh cart in the background.
      // Do NOT await this before restoring the button.
      renderDrawerFromCart()
        .then(() => {
          openCart();
        })
        .catch(error => {
          console.error('Cart drawer refresh error:', error);
          openCart();
        });

    } catch (error) {

      console.error('Add to cart error:', error);

      // Stop loading state
      button.dataset.loading = 'false';
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');

      // Show error
      button.innerHTML = window.SEEPA_I18N ? window.SEEPA_I18N.try_again : 'TRY AGAIN';

      setTimeout(() => {
        button.innerHTML = originalHTML;
      }, 1500);
    }
  });
}

  if ($('#cartClose')) $('#cartClose').onclick = closeCart;
  if (backdrop) backdrop.onclick = closeCart;
  if ($('#navCart')) $('#navCart').onclick = e => { e.preventDefault(); renderDrawerFromCart(); openCart(); };

  document.querySelectorAll('.accordion-summary').forEach(btn => {
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      const group = btn.closest('.accordion') || document;
      const willOpen = !item.classList.contains('open');
      // One open item per accordion
      group.querySelectorAll('.accordion-item').forEach(i => {
        i.classList.remove('open');
        const b = i.querySelector('.accordion-summary');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Cart badge: hide at zero and bounce when the count goes up. Several scripts write to #cartCount,
  // so watch the element itself instead of hooking each of them.
  const cartBadge = $('#cartCount');
  if (cartBadge) {
    let lastCount = parseInt(cartBadge.textContent, 10) || 0;
    new MutationObserver(() => {
      const count = parseInt(cartBadge.textContent, 10) || 0;
      cartBadge.classList.toggle('is-empty', count === 0);
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
      if (count > lastCount) {
        cartBadge.classList.remove('bump');
        void cartBadge.offsetWidth; // restart the animation
        cartBadge.classList.add('bump');
      }
      lastCount = count;
    }).observe(cartBadge, { childList: true, characterData: true, subtree: true });
  }

  // Menu links that jump to an on-page section are hidden on pages without that section (e.g. the FAQ)
  document.querySelectorAll('[data-requires-anchor]').forEach(link => {
    if (!document.getElementById(link.dataset.requiresAnchor)) link.hidden = true;
  });

  // Mobile menu
  const menuToggle = $('#menuToggle');
  const mobileMenu = $('#mobileMenu');
  const mobileMenuOverlay = $('#mobileMenuOverlay');
  const mobileMenuClose = $('#mobileMenuClose');

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.add('open');
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.classList.add('is-open');
    }
    document.body.classList.add('menu-open');
    // Move focus into the panel once it is visible
    setTimeout(() => { if (mobileMenuClose) mobileMenuClose.focus(); }, 50);
  }
  function closeMobileMenu(returnFocus) {
    if (!mobileMenu) return;
    const wasOpen = mobileMenu.classList.contains('open');
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('open');
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.classList.remove('is-open');
      if (wasOpen && returnFocus === true) menuToggle.focus();
    }
    document.body.classList.remove('menu-open');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', () => closeMobileMenu(true));
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', () => closeMobileMenu(true));
  document.querySelectorAll('.close-mobile-menu').forEach(link => {
    link.addEventListener('click', () => closeMobileMenu());
  });

  // Escape closes the menu; Tab stays inside it while it is open
  document.addEventListener('keydown', e => {
    if (!mobileMenu || !mobileMenu.classList.contains('open')) return;
    if (e.key === 'Escape') { closeMobileMenu(true); return; }
    if (e.key !== 'Tab') return;
    const items = Array.from(mobileMenu.querySelectorAll(FOCUSABLE)).filter(el => !el.hidden && el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // The menu's cart link opens the cart drawer like the header icon does
  document.querySelectorAll('[data-open-cart]').forEach(link => {
    link.addEventListener('click', e => {
      const navCart = $('#navCart');
      if (!navCart) return;
      e.preventDefault();
      closeMobileMenu();
      navCart.click();
    });
  });

  // Scroll reveal animations
  const revealTargets = [
    '.trust div',
    '.intro .label', '.intro h2', '.intro p',
    '.feature-media', '.feature-copy .label', '.feature-copy .section-title', '.feature-copy > p', '.list', '.feature-copy .outline',
    '.head .label', '.head .section-title', '.head p',
    '.product',
    '.purchase-media', '.purchase-copy .label', '.purchase-copy h2', '.purchase-copy > p', '.purchase-copy .option-label', '.swatches', '.size-row', '.buy-row',
    '.lifehead .label', '.lifehead h2', '.lifehead p',
    '.life',
    '.story .label', '.story .section-title', '.story > p', '.storymedia',
    '.news .section-title', '.news form'
  ];
  revealTargets.forEach(selector => {
    document.querySelectorAll(selector).forEach((el, i) => {
      el.classList.add('reveal');
      if (i < 4) el.classList.add('reveal-delay-' + (i + 1));
    });
  });

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05 });

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  renderDrawerFromCart();
  sync();

  window.renderDrawerFromCart = renderDrawerFromCart;
  window.openCart = openCart;
  window.closeCart = closeCart;

// Shopify Forms custom styling
const styleShopifyForms = () => {
  const host = document.querySelector('shopify-forms-embed');
  const shadowRoot = host?.shadowRoot;

  if (!shadowRoot) return;

  // Prevent duplicate styles
  if (shadowRoot.querySelector('#custom-shopify-forms-style')) return;

  const styleElement = document.createElement('style');
  styleElement.id = 'custom-shopify-forms-style';

  styleElement.textContent = `
   /* =========================================
   SHOPIFY FORMS — VENTO WELCOME OFFER
   ========================================= */

/* Main modal */
#form-container-ref {
  color: #171717 !important;
}

/* =========================================
   FORM CONTENT
   ========================================= */

#form-container-ref [data-testid="form"] {
  width: 100% !important;
}

/* =========================================
   MAIN HEADING
   "Your first step starts here"
   ========================================= */

#form-container-ref h2 {
  margin: 0 0 14px !important;

  color: #171717 !important;

  font-family: inherit !important;
  font-size: 23px !important;
  line-height: 1.25 !important;
  font-weight: 400 !important;

  letter-spacing: -0.02em !important;
  text-align: left !important;
}

/* =========================================
   SUPPORTING TEXT
   ========================================= */

#form-container-ref [class*="textBody"] {


  color: #777 !important;

  font-family: inherit !important;
  font-size: 12px !important;
  line-height: 1.65 !important;
  font-weight: 400 !important;

  text-align: left !important;
}

#form-container-ref [class*="textBody"] p {
  margin: 0 !important;
  font-size: 12px !important;
  line-height: 1.65 !important;
}


/* =========================================
   FIELD CONTAINERS
   ========================================= */

#form-container-ref [class*="formFieldContainer"] {
  margin-bottom: 22px !important;
}


/* =========================================
   INPUTS
   ========================================= */

#form-container-ref input[data-testid^="field-"] {
  width: 100% !important;

  box-sizing: border-box !important;

  background: transparent !important;

  color: #171717 !important;

  border: 0 !important;
  border-bottom: 1px solid #b8b5af !important;

  border-radius: 0 !important;

  padding: 8px 0 9px !important;

  font-family: inherit !important;
  font-size: 13px !important;
  line-height: 1.4 !important;

  outline: none !important;
  box-shadow: none !important;
}

#form-container-ref input[data-testid^="field-"]:focus {
  border-bottom-color: #171717 !important;
  box-shadow: none !important;
}
#form-container-ref input[data-testid^="field-"]:focus + label {
  top: 0px !important;
}
#form-container-ref label[class*="inputFilled"] {
  top: 0px !important;
  font-size: 8px !important;
}

/* =========================================
   LABELS
   ========================================= */

#form-container-ref label {
  color: #777 !important;

  font-family: inherit !important;
  font-size: 8px !important;
  line-height: 1 !important;
  font-weight: 400 !important;

  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
}


/* =========================================
   SUBMIT BUTTON
   ========================================= */

#form-container-ref button[data-testid="btn-form-submit"] {

  margin-top: 2px !important;

  background: #171717 !important;
  color: #fff !important;

  border: 1px solid #171717 !important;
  border-radius: 0 !important;

  padding: 14px 20px !important;

  font-family: inherit !important;
  font-size: 10px !important;
  line-height: 1 !important;
  font-weight: 500 !important;

  letter-spacing: 0.12em !important;
  text-transform: uppercase !important;

  cursor: pointer !important;

  transition: all .25s ease !important;
}

#form-container-ref button[data-testid="btn-form-submit"]:hover {
  background: transparent !important;
  color: #171717 !important;
}


/* =========================================
   DISCLAIMER
   ========================================= */

#form-container-ref [class*="formDisclaimer"] {
  margin-top: 12px !important;

  color: #999 !important;

  font-family: inherit !important;
  font-size: 8px !important;
  line-height: 1.5 !important;

  text-align: center !important;
}


/* =========================================
   CLOSE BUTTON
   ========================================= */

#form-container-ref [class*="formCloseButton"] {
  background: transparent !important;
  border-radius: 0 !important;
}

#form-container-ref [class*="formCloseButton"] svg {
  width: 12px !important;
  height: 12px !important;
}


/* =========================================
   TEASER
   ========================================= */

button[data-testid="form-teaser"] {
  background: var(--gold) !important;
  color: var(--cream) !important;

  border-radius: 0 !important;

  padding: 13px 18px !important;

  font-family: inherit !important;
}
  button[data-testid="form-teaser"]:hover {
  background: var(--gold2) !important;
}

button[data-testid="form-teaser"] h3 {
  margin: 0 !important;

  color: var(--cream) !important;

  font-size: 12px !important;
  line-height: 1.3 !important;
  font-weight: 500 !important;

  letter-spacing: 0.04em !important;
}

button[data-testid="form-teaser"] svg {
  fill:var(--cream) !important;
}

/* =========================================
   MOBILE
   ========================================= */

@media (max-width: 768px) {

  #form-container-ref h2 {
    font-size: 21px !important;
    text-align: center !important;
  }

  #form-container-ref [class*="textBody"] {
    font-size: 11.5px !important;
  }
    #form-container-ref [class*="textBody"] p{
      text-align: center !important;
  }

  #form-container-ref input[data-testid^="field-"] {
    font-size: 16px !important;
  }
    #form-container-ref [class*="formCloseButton"] svg {
    fill: #FDFDFD !important;
}
    #form-container-ref [class*="imageLoaded"] {
  background-position: center top !important;
}
  #form-container-ref [data-sizing="form-wrapper"] {
  grid-template-rows: 390px min-content;
}


}
  `;

  shadowRoot.appendChild(styleElement);
};


// Try immediately
styleShopifyForms();


// Shopify Forms can load dynamically
const shopifyFormsObserver = new MutationObserver(() => {
  styleShopifyForms();
});

shopifyFormsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

  // Language toggle is handled server-side via Shopify localization form in header.liquid
})();
